import AuthService from '../../AuthService';
const User = {
  getUser(page,search,sort_date){
    return AuthService.get(`user?page=${page}&search=${search}&sort_date=${sort_date}`);
  },
  showUser(id){
    return AuthService.get(`user/${id}`);
  },
  createUser(data){
    return AuthService.post(`user`,data);
  },
  updateUser(id,data){
    return AuthService.put(`user/${id}`,data);
  },
  deleteUser(id){
    return AuthService.delete(`user/${id}`);
  },
}
export default User
